import styled from "@emotion/styled/macro";
import { Link } from "react-router-dom";
import headerMobile from "../../assets/images/contactHeaderMobile.png";
import header from "../../assets/images/contactHeader.png";
import { BodyContentLayout } from "../../components/ui/ContentLayout";
import { useTranslation, Trans } from "react-i18next";
import PageHeader from "../../components/pageParts/PageHeader";
import CardPart from "../../components/pageParts/CardPart";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.colors.white};
`;
const WhiteContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 6em 2em;
  }
  display: flex;
  flex-direction: column;
  padding: 0 0 5em 0;
  line-height: 1.5em;
`;

const Subtitle = styled.h2`
  border-top: 1px solid ${({ theme }) => theme.colors.opal};
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.4em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
    padding: 0;
  }
`;

const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.primary};
  & a {
    text-decoration: underline;
  }
`;

const StyledCard = styled(CardPart)`
  padding-bottom: 5em;
`;

const Contact = () => {
  const { t } = useTranslation();

  const cards = ["insurance", "abroad", "accident"];

  return (
    <Container>
      <PageHeader
        title={t("contact.header.title")}
        subtitle={t("contact.header.subtitle")}
        subsubtitle={t("contact.header.subsubtitle")}
        text={t("contact.header.text")}
        background={header}
        imgMobile={headerMobile}
      />
      <WhiteContainer>
        <BodyContentLayout>
          <Subtitle>{t("contact.subtitle")}</Subtitle>
          <Text>
            <Trans i18nKey="contact.text">
              coverage. <br />
              <br />
              website
              <Link target="_blank" to={{ pathname: "https://www.fcgb-bgwf.be/" }} />
            </Trans>
          </Text>
        </BodyContentLayout>
      </WhiteContainer>
      <StyledCard cards={cards} />
    </Container>
  );
};

export default Contact;
